import React, { Component } from 'react';
import { BASE_URL, ADMIN_URL, SCREEN_SIZE } from "../constant";
import { commonAPI } from '../API/FetchCall';
import { Collapse, CardBody, Card, CardHeader } from 'reactstrap';

const footerLinks = [{"category_name":"Schools","category_id":1,"parent_id":0,"slug_term":"schools","subcategory":[{"category_name":"Open School","category_id":12,"parent_id":1,"slug_term":"open-schools","subcategory":[]},{"category_name":"Special Needs","category_id":133,"parent_id":1,"slug_term":"school-special-needs","subcategory":[]},{"category_name":"Public School","category_id":142,"parent_id":1,"slug_term":"public-schools","subcategory":[{"category_name":"IB","category_id":9,"parent_id":142,"slug_term":"ib"},{"category_name":"CBSE","category_id":14,"parent_id":142,"slug_term":"cbse"},{"category_name":"State Board / Matriculation","category_id":149,"parent_id":142,"slug_term":"state-board-matriculation"},{"category_name":"ICSE","category_id":150,"parent_id":142,"slug_term":"icse"},{"category_name":"IGCSE","category_id":151,"parent_id":142,"slug_term":"igcse"}]},{"category_name":"Private School","category_id":143,"parent_id":1,"slug_term":"private-schools","subcategory":[]},{"category_name":"Boarding School","category_id":144,"parent_id":1,"slug_term":"boarding-schools","subcategory":[]},{"category_name":"International School","category_id":145,"parent_id":1,"slug_term":"international-schools","subcategory":[]},{"category_name":"Alternative School","category_id":147,"parent_id":1,"slug_term":"alternative-schools","subcategory":[]},{"category_name":"E-School","category_id":174,"parent_id":1,"slug_term":"e-schools","subcategory":[]}]},{"category_name":"Pre-Schools","category_id":2,"parent_id":0,"slug_term":"pre-schools","subcategory":[{"category_name":"Kindergarten","category_id":16,"parent_id":2,"slug_term":"kindergarten","subcategory":[]},{"category_name":"Montessori","category_id":17,"parent_id":2,"slug_term":"montessori","subcategory":[]},{"category_name":"Play Group","category_id":18,"parent_id":2,"slug_term":"play-group","subcategory":[]},{"category_name":"Special Needs","category_id":20,"parent_id":2,"slug_term":"special-needs","subcategory":[]},{"category_name":"Day care or Creche","category_id":175,"parent_id":2,"slug_term":"day-care-or-creche","subcategory":[]}]},{"category_name":"Kids Play Areas","category_id":3,"parent_id":0,"slug_term":"kids-play-area","subcategory":[{"category_name":"Indoor","category_id":22,"parent_id":3,"slug_term":"indoor","subcategory":[]},{"category_name":"Outdoor","category_id":23,"parent_id":3,"slug_term":"outdoor","subcategory":[]}]},{"category_name":"After School Activity","category_id":4,"parent_id":0,"slug_term":"after-school-activity","subcategory":[{"category_name":"Sports","category_id":26,"parent_id":4,"slug_term":"sports","subcategory":[{"category_name":"Football","category_id":33,"parent_id":26,"slug_term":"football"},{"category_name":"Tennis","category_id":34,"parent_id":26,"slug_term":"tennis"},{"category_name":"Cricket","category_id":35,"parent_id":26,"slug_term":"cricket"},{"category_name":"Swimming","category_id":36,"parent_id":26,"slug_term":"swimming"},{"category_name":"Hockey","category_id":37,"parent_id":26,"slug_term":"hockey"},{"category_name":"Badminton","category_id":38,"parent_id":26,"slug_term":"badminton"},{"category_name":"Gymnastics","category_id":39,"parent_id":26,"slug_term":"gymnastics"},{"category_name":"Athletics & Running","category_id":40,"parent_id":26,"slug_term":"athletics-running"},{"category_name":"Boxing & Wrestling","category_id":41,"parent_id":26,"slug_term":"boxing-wrestling"},{"category_name":"Karate & Martial Arts","category_id":42,"parent_id":26,"slug_term":"martial-arts-karate"},{"category_name":"Trekking & Rock Climbing","category_id":43,"parent_id":26,"slug_term":"trekking-rock-climbing"},{"category_name":"All Others","category_id":44,"parent_id":26,"slug_term":"all-others"},{"category_name":"Chess","category_id":45,"parent_id":26,"slug_term":"chess"},{"category_name":"Basketball","category_id":46,"parent_id":26,"slug_term":"basketball"},{"category_name":"Golf","category_id":47,"parent_id":26,"slug_term":"golf"},{"category_name":"Archery","category_id":48,"parent_id":26,"slug_term":"archery"},{"category_name":"Go Karting","category_id":49,"parent_id":26,"slug_term":"go-karting"},{"category_name":"Skating","category_id":50,"parent_id":26,"slug_term":"skating"},{"category_name":"Table Tennis","category_id":51,"parent_id":26,"slug_term":"table-tennis"}]},{"category_name":"Music","category_id":27,"parent_id":4,"slug_term":"music","subcategory":[{"category_name":"Vocal","category_id":57,"parent_id":27,"slug_term":"singing-classes"},{"category_name":"Instrumental","category_id":58,"parent_id":27,"slug_term":"instrumental"}]},{"category_name":"Dance and Theatre","category_id":28,"parent_id":4,"slug_term":"dance-and-theatre","subcategory":[{"category_name":"Bharatnatyam","category_id":78,"parent_id":28,"slug_term":"bharatnatyam"},{"category_name":"Kuchipudi","category_id":79,"parent_id":28,"slug_term":"kuchipudi"},{"category_name":"Odissi","category_id":80,"parent_id":28,"slug_term":"odissi"},{"category_name":"Kathak","category_id":81,"parent_id":28,"slug_term":"kathak"},{"category_name":"Bollywood","category_id":82,"parent_id":28,"slug_term":"bollywood"},{"category_name":"Salsa and similar dance","category_id":162,"parent_id":28,"slug_term":"salsa-and-similar-dance"},{"category_name":"Hip Hop","category_id":163,"parent_id":28,"slug_term":"hip-hop"},{"category_name":"Other dance forms","category_id":164,"parent_id":28,"slug_term":"other-dance-forms"},{"category_name":"Theatre","category_id":165,"parent_id":28,"slug_term":"theatre"},{"category_name":"Ballet","category_id":166,"parent_id":28,"slug_term":"ballet"}]},{"category_name":"Creative Arts","category_id":29,"parent_id":4,"slug_term":"creative-arts","subcategory":[{"category_name":"Drawing & Painting","category_id":134,"parent_id":29,"slug_term":"drawing-painting"},{"category_name":"Pottery","category_id":135,"parent_id":29,"slug_term":"pottery"},{"category_name":"Arts & Crafts","category_id":167,"parent_id":29,"slug_term":"arts-crafts"}]},{"category_name":"Mind & Skills Enrichment","category_id":179,"parent_id":4,"slug_term":"mind-and-skill-enrichment","subcategory":[{"category_name":"Yoga","category_id":30,"parent_id":179,"slug_term":"yoga"},{"category_name":"Abacus","category_id":87,"parent_id":179,"slug_term":"abacus"},{"category_name":"Kumon","category_id":88,"parent_id":179,"slug_term":"kumon"},{"category_name":"Vedic Math","category_id":89,"parent_id":179,"slug_term":"vedic-math"},{"category_name":"Balvihar","category_id":91,"parent_id":179,"slug_term":"balvihar"},{"category_name":"Shloka Classes","category_id":92,"parent_id":179,"slug_term":"shloka-classes"},{"category_name":"Coding","category_id":185,"parent_id":179,"slug_term":"coding"}]},{"category_name":"Hobbies & Passion","category_id":180,"parent_id":4,"slug_term":"hobbies-and-passion","subcategory":[{"category_name":"Cooking & baking","category_id":181,"parent_id":180,"slug_term":"cooking-and-baking"},{"category_name":"Story telling","category_id":182,"parent_id":180,"slug_term":"story-telling"},{"category_name":"Quizzes","category_id":183,"parent_id":180,"slug_term":"quizzes"}]}]},{"category_name":"Tuitions","category_id":6,"parent_id":0,"slug_term":"tuitions","subcategory":[{"category_name":"Maths","category_id":94,"parent_id":6,"slug_term":"maths","subcategory":[]},{"category_name":"Science/ EVS","category_id":95,"parent_id":6,"slug_term":"science","subcategory":[]},{"category_name":"Economics","category_id":98,"parent_id":6,"slug_term":"economics","subcategory":[]},{"category_name":"Business Studies","category_id":99,"parent_id":6,"slug_term":"business-studies","subcategory":[]},{"category_name":"Languages","category_id":101,"parent_id":6,"slug_term":"languages","subcategory":[{"category_name":"French","category_id":102,"parent_id":101,"slug_term":"french"},{"category_name":"Spanish","category_id":103,"parent_id":101,"slug_term":"spanish"},{"category_name":"Mandarin","category_id":104,"parent_id":101,"slug_term":"mandarin"},{"category_name":"Sanskrit","category_id":107,"parent_id":101,"slug_term":"sanskrit"},{"category_name":"English","category_id":159,"parent_id":101,"slug_term":"english"},{"category_name":"German","category_id":161,"parent_id":101,"slug_term":"german"},{"category_name":"Hindi","category_id":189,"parent_id":101,"slug_term":"hindi"},{"category_name":"Tamil","category_id":190,"parent_id":101,"slug_term":"tamil"},{"category_name":"Kannada","category_id":191,"parent_id":101,"slug_term":"kannada"}]},{"category_name":"Social sciences","category_id":187,"parent_id":6,"slug_term":"social-science","subcategory":[]}]},{"category_name":"Birthday & Events","category_id":7,"parent_id":0,"slug_term":"birthday-event","subcategory":[{"category_name":"Venues","category_id":110,"parent_id":7,"slug_term":"venues","subcategory":[]},{"category_name":"Bakery or Cake shops","category_id":111,"parent_id":7,"slug_term":"bakery-or-cake-shops","subcategory":[]},{"category_name":"Entertainers or MCs","category_id":112,"parent_id":7,"slug_term":"entertainers-or-mcs","subcategory":[]},{"category_name":"Party Planners","category_id":113,"parent_id":7,"slug_term":"party-planners","subcategory":[]},{"category_name":"Gifts & Supportives","category_id":178,"parent_id":7,"slug_term":"gift-and-supportives","subcategory":[]}]},{"category_name":"Learning Camps","category_id":8,"parent_id":0,"slug_term":"learning-camps","subcategory":[{"category_name":"Below 4 Years","category_id":117,"parent_id":8,"slug_term":"below-4-years","subcategory":[{"category_name":"5 - 7 years","category_id":157,"parent_id":117,"slug_term":"5-7-years"},{"category_name":"8 - 10 years","category_id":158,"parent_id":117,"slug_term":"8-10-years"},{"category_name":"11 - 12 years","category_id":170,"parent_id":117,"slug_term":"11-12-years"},{"category_name":"13 - 15 years","category_id":171,"parent_id":117,"slug_term":"13-15-years"}]},{"category_name":"5 - 7 Years","category_id":118,"parent_id":8,"slug_term":"5-7-years","subcategory":[]},{"category_name":"8 - 10 Years","category_id":119,"parent_id":8,"slug_term":"8-10-years","subcategory":[]},{"category_name":"11 - 12 Years","category_id":120,"parent_id":8,"slug_term":"11-12-years","subcategory":[]},{"category_name":"13 - 15 Years","category_id":172,"parent_id":8,"slug_term":"13-15-years","subcategory":[]},{"category_name":"BeWise Curated Learning camps","category_id":184,"parent_id":8,"slug_term":"curated-learning-camps","subcategory":[]}]},{"category_name":"Community Support","category_id":121,"parent_id":0,"slug_term":"community-support","subcategory":[{"category_name":"Counselor","category_id":122,"parent_id":121,"slug_term":"counselor","subcategory":[]},{"category_name":"Articles and Blogs","category_id":124,"parent_id":121,"slug_term":"articles-blogs","subcategory":[]},{"category_name":"Growth Partnerships","category_id":186,"parent_id":121,"slug_term":"growth-partnerships-for-you","subcategory":[]}]}];
class WebCateogry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: -1,
      collapselead:999,
      location: localStorage.getItem('current_location') ? localStorage.getItem('current_location') : 'Bengaluru',
      category: footerLinks
    };
    //this.getCategory();
  }
  componentDidMount() {
  }
  toggle(event) {
    this.setState({
      collapse: this.state.collapse === Number(event) ? -2 : Number(event),
      
    });
  }
  togglelead(event) {
    this.setState({
     collapselead: this.state.collapselead === Number(event) ? -2 : Number(event)
    });
  }
  getCategory = () => {
    let req = JSON.stringify({ url: 'getcategoryByPid', pid: 0 });
    commonAPI(req).then(res => { this.setState({ category: res.results }) })
  }
  render() {
    const { category, collapse, collapselead } = this.state;
    let citylocation = this.state.location.toLowerCase() == 'bengaluru' ? 'Bangalore' : this.state.location;
    console.log('citylocation', this.state.location, citylocation)
    let isMobile = (SCREEN_SIZE < 767 || SCREEN_SIZE<1180) ? true : false;
    let scllist = category.filter(item => item.category_id == 1);
    if (scllist.length > 0)
      scllist = scllist[0];
    let prescl = category.filter((item) => item.category_id == 2)
    if (prescl.length > 0)
      prescl = prescl[0];
    let playarea = category.filter((item) => item.category_id == 3)
    if (playarea.length > 0)
      playarea = playarea[0];
    let afterscl = category.filter((item) => item.category_id == 4)
    if (afterscl.length > 0)
      afterscl = afterscl[0];
    let tuition = category.filter((item) => item.category_id == 6)
    if (tuition.length > 0)
      tuition = tuition[0];
    let learn = category.filter((item) => item.category_id == 8)
    if (learn.length > 0)
      learn = learn[0];
    let community = category.filter((item) => item.category_id == 121)
    if (community.length > 0)
      community = community[0];
    let bevents = category.filter((item) => item.category_id == 7)
    if (bevents.length > 0)
      bevents = bevents[0];
    let city_slug = this.state.location.toLowerCase();
    return (
      <React.Fragment>
        {!isMobile && (
          <div className="row">
            <div className="col-2">
              <div className="tile-cate-container">
                <div className="footer-cate-title">
                  <span>School</span>
                </div>
                <div className="footer-cate-inner">
                  {scllist.subcategory && scllist.subcategory.map((item, i) => {
                    return (
                      <div>
                        <a href={`/${city_slug}/${scllist.slug_term}/${item.slug_term}`}>
                          {item.category_name} in {citylocation}
                        </a>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div className="tile-cate-container">
                <div className="footer-cate-title">
                  <span>Pre School</span>
                </div>
                <div className="footer-cate-inner">
                  {prescl.subcategory && prescl.subcategory.map((item, i) => {
                    return (
                      <div>
                        <a href={`/${city_slug}/${prescl.slug_term}/${item.slug_term}`}>
                          {item.category_name} in {citylocation}
                        </a>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div className="tile-cate-container">
                <div className="footer-cate-title">
                  <span>Tuitions</span>
                </div>
                <div className="footer-cate-inner">
                  {tuition.subcategory && tuition.subcategory.map((item, i) => {
                    return (
                      <React.Fragment>
                        {item.subcategory.length === 0 && (
                          <div>
                            <a href={`/${city_slug}/${tuition.slug_term}/${item.slug_term}`}>
                              {item.category_name} in {citylocation}
                            </a>
                          </div>
                        )}
                        {item.subcategory && item.subcategory.map((items, j) => {
                          return (
                            <div>
                              <a href={`/${city_slug}/${tuition.slug_term}/${item.slug_term}/${items.slug_term}`}>
                                {items.category_name} - {item.category_name} in {citylocation}
                              </a>
                            </div>
                          )
                        })}
                      </React.Fragment>
                    )
                  })}
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="tile-cate-container">
                <div className="footer-cate-title">
                  <span>After School Acitvity</span>
                </div>
                <div className="footer-cate-inner">
                  {afterscl.subcategory && afterscl.subcategory.map((item, i) => {
                    if (i < 1)
                      return (
                        <React.Fragment>
                          {item.subcategory && item.subcategory.map((items, j) => {
                            return (
                              <div>
                                <a href={`/${city_slug}/${afterscl.slug_term}/${item.slug_term}/${items.slug_term}`}>
                                  {items.category_name} - {item.category_name} in {citylocation}
                                </a>
                              </div>
                            )
                          })}
                        </React.Fragment>
                      )
                  })}
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="tile-cate-container">
                <div className="footer-cate-title">
                  <span>After School Acitvity</span>
                </div>
                <div className="footer-cate-inner">
                  {afterscl.subcategory && afterscl.subcategory.map((item, i) => {
                    if (i > 1)
                      return (
                        <React.Fragment>
                          {item.subcategory && item.subcategory.map((items, j) => {
                            return (
                              <div>
                                <a href={`/${city_slug}/${afterscl.slug_term}/${item.slug_term}/${items.slug_term}`}>
                                  {items.category_name} - {item.category_name} in {citylocation}
                                </a>
                              </div>
                            )
                          })}
                        </React.Fragment>
                      )
                  })}
                </div>
              </div>
            </div>
            <div className="col-2">
              <div className="tile-cate-container">
                <div className="footer-cate-title">
                  <span>Kids Play Area</span>
                </div>
                <div className="footer-cate-inner">
                  {playarea.subcategory && playarea.subcategory.map((item, i) => {
                    return (
                      <div>
                        <a href={`/${city_slug}/${playarea.slug_term}/${item.slug_term}`}>
                          {item.category_name} in {citylocation}
                        </a>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div className="tile-cate-container">
                <div className="footer-cate-title">
                  <span>Learning Camps</span>
                </div>
                <div className="footer-cate-inner">
                  {learn.subcategory && learn.subcategory.map((item, i) => {
                    return (
                      <React.Fragment>
                        {item.slug_term == 'curated-learning-camps' ?
                          (
                            <div>
                              <a href={`/${learn.slug_term}/${item.slug_term}`}>
                                {item.category_name} in {citylocation}
                              </a>
                            </div>
                          ) : (
                            <div>
                              <a href={`/${city_slug}/${learn.slug_term}/${item.slug_term}`}>
                                {item.category_name} in {citylocation}
                              </a>
                            </div>
                          )}

                      </React.Fragment>
                    )
                  })}
                </div>
              </div>
              <div className="tile-cate-container">
                <div className="footer-cate-title">
                  <span>Birthday Events</span>
                </div>
                <div className="footer-cate-inner">
                  {bevents.subcategory && bevents.subcategory.map((item, i) => {
                    return (
                      <div>
                        <a href={`/${city_slug}/${bevents.slug_term}/${item.slug_term}`}>
                          {item.category_name} in {citylocation}
                        </a>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div className="tile-cate-container">
                <div className="footer-cate-title">
                  <span>Community Support</span>
                </div>
                <div className="footer-cate-inner">
                  {community.subcategory && community.subcategory.map((item, i) => {
                    return (
                      <div>
                        <a href={`/${city_slug}/${community.slug_term}/${item.slug_term}`}>
                          {item.category_name} in {citylocation}
                        </a>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
            <div className="col-2">
              <div className="tile-cate-container">
                <div className="footer-cate-title">
                  <span>Corporate Info</span>
                </div>
                {this.corprateinfo()}
              </div>

              <div className="tile-cate-container">
                <div className="footer-cate-title">
                  <span>Other Info</span>
                </div>
                <div className="footer-cate-inner">
                      <div>
                        <a href="/best-tuitions-near-me">
                         Best Tuition Near Me
                        </a>
                      </div> 
                      <div>
                        <a href="/best-schools-near-me">
                         Best Schools Near me
                        </a>
                      </div> 
                      <div>
                        <a href="/best-preschools-near-me">
                          Best Preschool Near Me
                        </a>
                      </div>

                      <div>
                        <a href="/best-sports-classes-near-me">
                          Best Sports Classes Near Me
                        </a>
                      </div>

                      <div>
                        <a href="/best-music-classes-near-me">
                          Best Music Classes Near Me
                        </a>
                      </div>

                      <div>
                        <a href="/best-dance-classes-near-me">
                        Best Dance Classes Near Me</a>
                      </div>
                      <div>
                        <a href="/best-arts-classes-near-me">
                        Best Art Classes Near Me</a>
                      </div>
                      <div>
                        <a href="/best-skill-enrichment-classes-near-me">
                          Best Top Skill Enrichment Classes Near Me</a>
                      </div>
                      <div>
                        <a href="/best-hobby-passion-enriching-classes-near-me">
                            Best Top Hobby And Passion Enriching Classes Near Me
                         </a>
                      </div>

                      <div>
                       <a href={`https://collegecampus.bewise.in/`} target='_blank'>
                          College Campus
                        </a>
                      </div>
                </div>
              </div>

             

            </div>
          </div>
        )}
        {isMobile && (
          <div className="row">

          <div className='col-lg-12'>
              <Card className='panel-group custom-card ft-card-mob' style={{ marginBottom: '1rem' }}>
                <CardHeader onClick={() => this.togglelead(999)} data-event={999} className='ft-card-mob-heading custom-card-heading'>
                  <b>Other Info</b>
                  {collapselead !== 999 ? (
                    <span className='pull-right'>
                      <i class="fa fa-chevron-right" aria-hidden="true"></i>
                    </span>
                  ) : (
                    <span className='pull-right'>
                      <i class="fa fa-chevron-down" aria-hidden="true"></i>
                    </span>
                  )}
                </CardHeader>
                <Collapse isOpen={collapselead === 999}>
                  <CardBody className='panel-body ft-card-mob-body'>
                   <div class="footer-cate-inner">
                    <div>
                        <a href="/best-tuitions-near-me">
                         Best Tuition Near Me
                        </a>
                      </div> 
                      <div>
                        <a href="/best-schools-near-me">
                         Best Schools Near me
                        </a>
                      </div> 
                      <div>
                        <a href="/best-preschools-near-me">
                          Best Preschool Near Me
                        </a>
                      </div>

                      <div>
                        <a href="/best-sports-classes-near-me">
                          Best Sports Classes Near Me
                        </a>
                      </div>

                      <div>
                        <a href="/best-music-classes-near-me">
                          Best Music Classes Near Me
                        </a>
                      </div>

                      <div>
                        <a href="/best-dance-classes-near-me">
                        Best Dance Classes Near Me</a>
                      </div>
                      <div>
                        <a href="/best-arts-classes-near-me">
                        Best Art Classes Near Me</a>
                      </div>
                      <div>
                        <a href="/best-skill-enrichment-classes-near-me">
                          Best Top Skill Enrichment Classes Near Me</a>
                      </div>
                      <div>
                        <a href="/best-hobby-passion-enriching-classes-near-me">
                            Best Top Hobby And Passion Enriching Classes Near Me
                         </a>
                      </div>
                    </div>                      
                  </CardBody>
                </Collapse>
              </Card>
            </div>

            <div className='col-lg-12'>
              <Card className='panel-group custom-card ft-card-mob' style={{ marginBottom: '1rem' }}>
                <CardHeader onClick={() => this.toggle(-1)} data-event={-1} className='ft-card-mob-heading custom-card-heading'>
                  <b>Corporate Info</b>
                  {collapse !== -1 ? (
                    <span className='pull-right'>
                      <i class="fa fa-chevron-right" aria-hidden="true"></i>
                    </span>
                  ) : (
                    <span className='pull-right'>
                      <i class="fa fa-chevron-down" aria-hidden="true"></i>
                    </span>
                  )}
                </CardHeader>
                <Collapse isOpen={collapse === -1}>
                  <CardBody className='panel-body ft-card-mob-body'>
                    {this.corprateinfo()}
                  </CardBody>
                </Collapse>
              </Card>
            </div>
            <div className='col-lg-12'>
              <Card className='panel-group custom-card ft-card-mob' style={{ marginBottom: '1rem' }}>
                {category.map((item, index) => {
                  return (
                    <React.Fragment>
                      <CardHeader onClick={() => this.toggle(index)} data-event={index} className='ft-card-mob-heading custom-card-heading'>
                        <b>{item.category_name} </b>
                        {collapse !== index ? (
                          <span className='pull-right'>
                            <i class="fa fa-chevron-right" aria-hidden="true"></i>
                          </span>
                        ) : (
                          <span className='pull-right'>
                            <i class="fa fa-chevron-down" aria-hidden="true"></i>
                          </span>
                        )}
                      </CardHeader>
                      <Collapse isOpen={collapse === index}>
                        <CardBody className='panel-body ft-card-mob-body'>
                          <div className="footer-cate-inner">
                            {item.subcategory && item.subcategory.map((items, i) => {
                              return (
                                <React.Fragment>
                                  {items.subcategory.length > 0 ? (
                                    items.subcategory.map((titem, j) => {
                                      return (
                                        <div>
                                          <a href={`/${city_slug}/${item.slug_term}/${items.slug_term}/${titem.slug_term}`}>
                                            {titem.category_name} - {items.category_name} in {citylocation}
                                          </a>
                                        </div>
                                      )
                                    })

                                  ) : (
                                    <div>
                                      <a href={`/${city_slug}/${item.slug_term}/${items.slug_term}`}>
                                        {items.category_name} in {citylocation}
                                      </a>
                                    </div>
                                  )}
                                </React.Fragment>
                              )
                            })}
                          </div>
                        </CardBody>
                      </Collapse>

                    </React.Fragment>
                  )
                })}
              </Card>
            </div>

            <div className='col-lg-12'>
              <Card className='panel-group custom-card ft-card-mob' style={{ marginBottom: '1rem' }}>
                <CardHeader onClick={() => this.toggle(-1)} data-event={-1} className='ft-card-mob-heading custom-card-heading'>
                  <b>College Connect</b>
                  {collapse !== -1 ? (
                    <span className='pull-right'>
                      <i class="fa fa-chevron-right" aria-hidden="true"></i>
                    </span>
                  ) : (
                    <span className='pull-right'>
                      <i class="fa fa-chevron-down" aria-hidden="true"></i>
                    </span>
                  )}
                </CardHeader>
                <Collapse isOpen={collapse === -1}>
                  <CardBody className='panel-body ft-card-mob-body'>
                      <div>
                        <a href={`https://collegecampus.bewise.in/`} target='_blank'>
                          College Campus
                        </a>
                      </div>
                  </CardBody>
                </Collapse>
              </Card>
            </div>

          </div>
        )}

      </React.Fragment>
    );
  }
  corprateinfo = () => {
    return (
      <div className="footer-cate-inner">
        <div>
          <a href="/about">About BeWise</a>
        </div>
        <div>
          <a href={`${ADMIN_URL}joinus`} target='_blank'>Partner Program – Educator / institutions</a>
        </div>
        { /* <div>
          <a href={`${ADMIN_URL}institution`} target='_blank'>Partner Program – Institution</a>
        </div> */ }
        <div>
          <a href="javascript:window.open('/termsconditions', 'termsconditions', 'width=auto,height=auto')">Terms & Conditions</a>
        </div>
        <div>
          <a href="javascript:window.open('/privacypolicy', 'privacypolicy', 'width=auto,height=auto')">Privacy Policy</a>
        </div>
        <div data-toggle="modal" data-target="#postQueryModal">
          <span class="cursorpointer">Contact Us</span>
        </div>
        <div data-toggle="modal" data-target="#feedBackModal">
        <span class="cursorpointer">Give us Feedback</span>
        </div>
        <div>
          <a href="mailto:contact@bewise.in">Work for BeWise</a>
        </div>
        {
          ((this.state.authe === true) && (window.location.pathname) != '/funlearning') ?
            <div >
              <a href="/funlearning" target='_blank'>Fun and Learning</a></div>
            :
            ((!this.state.authe) && (window.location.pathname) != '/funlearning') &&
            <div>
              <a href="/signin?prev_path=/funlearning" target='_blank'>Fun and Learning</a>
            </div>
        }
      </div>
    )
  }
}
export { WebCateogry };

